import { Injectable, inject } from '@angular/core';
import { DashboardMySalesService } from '../../../services/dashboard-my-sales.service';
import { DashboardList } from './dashboard-list';
import { DashboardFilter } from '../../../services';
import { Observable } from 'rxjs';
import { PaginateResult } from '../../models';
import { DashboardMethod } from '../../../services/dashboard-data-service.interface';

@Injectable({
  providedIn: 'root',
})
export abstract class DashboardMySalesList extends DashboardList {
  protected mySalesService = inject(DashboardMySalesService);

  protected override invokeDashboard(method: DashboardMethod, filter: DashboardFilter): Observable<PaginateResult> {
    return this.mySalesService[method](filter);
  }
}
